import React, { useEffect, useState } from "react";
import Header from "../Components/Header";
import PageHeader from "../Components/PageHeader";
import Footer from "../Components/Footer";
import { Link } from "react-router-dom";
import {
  howimg,
  mobile3,
  mobile2,
  workgoogleplay,
  workappstore,
} from "../Constant/Index";
import { contentApi } from "../network/Network";

const HowItWork = () => {
  let currentUrl = window.location.href.split("/");
  const [getapi, setGetapi] = useState("");

  // how it work on
  useEffect(() => {
    contentApi(currentUrl[3])
      .then((res) => {
        setGetapi(res?.data);
      })
      .catch((err) => {});
  }, []);
  // ==================
  return (
    <>
      <Header />
      <PageHeader pagename="How it works" />
      <section className="how-it-work">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="solve-detail-img ">
                <div className="row align-items-center">
                  <div className="col-lg-6 position-relative">
                    <div className="how-it-work-img">
                      <figure>
                        <img
                          src={getapi?.sectionOne?.image}
                          className="img-fluid "
                          alt=""
                        />
                      </figure>
                    </div>
                  </div>
                  <div className="col-lg-6 mt-5 ps-0">
                    <div className="solved-heading pe-4">
                      <h3 className="main-heading-font dark-color level-2 wow animate__ animate__zoomIn animated">
                        {getapi?.sectionOne?.heading_1}
                      </h3>
                      <p
                        className="primary-regular-font extra-color-5 level-7"
                        dangerouslySetInnerHTML={{
                          __html: getapi?.sectionOne?.paragraph_1,
                        }}
                      />
                      <h4 className="main-heading-font dark-color level-3 wow animate__ animate__zoomIn animated">
                        {/* Secure authentication */}
                        {getapi?.sectionOne?.heading_2}
                      </h4>
                      <p
                        className="primary-regular-font extra-color-5 level-7"
                        dangerouslySetInnerHTML={{
                          __html: getapi?.sectionOne?.paragraph_2,
                        }}
                      />
                      <h4 className="main-heading-font dark-color level-3 wow animate__ animate__zoomIn animated">
                        {/* Real-time monitoring */}
                        {getapi?.sectionOne?.heading_3}
                      </h4>
                      <p
                        className="primary-regular-font extra-color-5 level-7"
                        dangerouslySetInnerHTML={{
                          __html: getapi?.sectionOne?.paragraph_3,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="get-our-app">
        <div className="container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="row extra-bg-8 radius-20 p-5 position-relative">
                <div className="col-lg-6 mx-auto">
                  <div className="row">
                    <div className="col-lg-12">
                      <h2 className="main-heading-font dark-color extra-color-5  level-2 ">
                        {/* Get our app */}
                        {/* Download Our App for Instant Healthcare Access */}
                        {getapi?.sectionTwo?.heading}
                      </h2>
                      <div className="">
                        <p
                          className="primary-regular-font extra-color-5  level-7"
                          dangerouslySetInnerHTML={{
                            __html: getapi?.sectionTwo?.note,
                          }}
                        >
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="row align-items-center">
                    <div className="col-lg-8">
                      <div className="  d-flex align-items-center gap-3 mt-3">
                        <Link className="bg-store" to="">
                          <img
                            src={workgoogleplay}
                            className="img-fluid"
                            alt=""
                          />
                        </Link>
                        <Link className="bg-store" to="">
                          <img
                            src={workappstore}
                            className="img-fluid"
                            alt=""
                          />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="mobile-img position-absolute ">
                    <div className="row">
                      <div className="col-lg-6 mt-5">
                        <img src={mobile3} className="img-fluid" alt="" />
                      </div>
                      <div className="col-lg-6">
                        <img
                          src={mobile2}
                          className="img-fluid position-relative add-position"
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default HowItWork;
